import type { IOption } from "@components/ui-kit";
import { t } from "@lingui/macro";
import { makeObservable, observable } from "mobx";
import React from "react";
import type { OtherDocumentModel } from "../../models";
import { RelatedTo } from "../contract/StoreContractForm";
import { FormOtherDocument } from "./FormOtherDocument";

export class StoreOtherDocumentForm {
  @observable.ref form = new FormOtherDocument();
  @observable.ref contractorOptions: IOption[] = [];
  @observable.ref brandOptions: IOption[] = [];
  @observable.ref projectOptions: IOption[] = [];
  @observable.ref clientOptions: IOption[] = [];

  @observable.ref projectsInputVal = "";

  @observable.ref relatedToOptions: IOption[] = [
    { label: t`Client`, value: RelatedTo.Client },
    { label: t`Brand`, value: RelatedTo.Brand },
    { label: t`Contractor`, value: RelatedTo.Contractor },
    { label: t`Projects`, value: RelatedTo.Projects },
  ];

  constructor() {
    makeObservable(this);
  }

  fillOtherDocumentForm(OtherDocument: OtherDocumentModel) {
    this.form.title.onChange(OtherDocument.title);
    this.form.brand_id.onChange(OtherDocument.brands?.[0]?.id);
    this.form.client_id.onChange(OtherDocument.clients?.[0]?.id);
    this.form.contractor_id.onChange(OtherDocument.contractors?.[0]?.id);
    this.form.project_ids.onChange(OtherDocument.projects.map((p) => p.id));
    if (OtherDocument.brands.length) {
      this.form.related_to.onChange(RelatedTo.Brand);
    }
    if (OtherDocument.clients.length) {
      this.form.related_to.onChange(RelatedTo.Client);
    }
    if (OtherDocument.contractors.length) {
      this.form.related_to.onChange(RelatedTo.Contractor);
    }
    if (OtherDocument.projects.length) {
      this.form.related_to.onChange(RelatedTo.Projects);
    }

    this.form.files.onChange(OtherDocument.files);
  }

  static create() {
    return new StoreOtherDocumentForm();
  }
}

export const FormOtherDocumentCtx = React.createContext<StoreOtherDocumentForm>(
  null as any as StoreOtherDocumentForm,
);
